import { render } from "./FbSectionField.vue?vue&type=template&id=23e6a8b3"
import script from "./FbSectionField.vue?vue&type=script&lang=js"
export * from "./FbSectionField.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__